<template>
    <TransitionGroup>
        <AppCard v-if="loading" v-for="i in items" :key="i" class="flex flex-col items-center justify-center animate-pulse">
            <div class="h-28 w-full mb-2 bg-muted"></div>
            <div class="h-12 w-full mb-2 bg-muted"></div>
            <p class="text-dark mb-2 px-4 text-center min-h-content flex-grow flex items-center bg-muted w-1/2">&nbsp;</p>
            <div class="flex items-center mb-2 mt-2">
                <div class="flex space-x-2 mr-auto">
                    <div class="flex-1 w-5 text-center">
                        <p class="bg-muted">&nbsp;</p>
                    </div>
                    <div class="flex-1 w-5 text-center">
                        <p class="bg-muted">&nbsp;</p>
                    </div>
                    <div class="flex-1 w-5 text-center">
                        <p class="bg-muted">&nbsp;</p>
                    </div>
                    <div class="flex-1 w-5 text-center">
                        <p class="bg-muted">&nbsp;</p>
                    </div>
                    <div class="flex-1 w-5 text-center">
                        <p class="bg-muted">&nbsp;</p>
                    </div>
                </div>
            </div>
            <div class="mt-2 w-1/2 bg-muted">&nbsp;</div>
        </AppCard>
    </TransitionGroup>
</template>

<script>
import AppCard from "@/Components/AppCard";
export default {
    name: "TyreCardLoader",
    components: {
        AppCard
    },
    props:
        {
            loading: {
                type: Boolean,
                default: true
            },
            items: {
                type: Number,
                default: 3
            }
        }
}
</script>

<style scoped>

</style>
